import t from 'react-translate';
import { useContext } from 'react';
import MentoringProgramContext from '../../context';
import { css } from '@emotion/react';
import { gray5, white } from 'styles/global_defaults/colors';
import { halfSpacing, quarterSpacing, standardSpacing } from 'styles/global_defaults/scaffolding';
import { MentoringProgramMatchingType } from 'redux/schemas/models/mentoring-programs';
import { MATCHING_TYPE_COLORS } from './constants';
import ParticipantDrivenMatchingConfiguration from './participant-driven-matching-configuration';
import AssignedMatchingConfiguration from './assigned-matching-configuration';

const styles = (backgroundColor: string) => css`
  border: 1px solid ${gray5};
  padding: ${standardSpacing}px;
  border-radius: ${halfSpacing}px;

  .matching-type-configuration-header {
    gap: ${quarterSpacing}px;
    border-bottom: 1px solid ${gray5};
  }

  .selected-matching-type {
    border-radius: 100px;
    color: ${white};
    padding: 7px ${halfSpacing}px;
    background: ${backgroundColor};
  }
`;

const MatchingTypeConfiguration = () => {
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { matchingType } = mentoringProgram || {};
  const translationBase =
    t.MENTORING_PROGRAMS.SETTINGS.TABS.MATCHING_SETTINGS.MATCHING_TYPE;
  const configurations = {
    [MentoringProgramMatchingType.PARTICIPANT_DRIVEN]: {
      title: translationBase.OPTIONS.PARTICIPANT_DRIVEN.TITLE(),
      ConfigurationComponent: ParticipantDrivenMatchingConfiguration,
    },
    [MentoringProgramMatchingType.AUTOMATED_MATCHING]: {
      title: translationBase.OPTIONS.ASSIGNED.TITLE(),
      ConfigurationComponent: AssignedMatchingConfiguration,
    },
  };

  const { title, ConfigurationComponent } = configurations[matchingType] || {};

  return (
    <div css={styles(MATCHING_TYPE_COLORS[matchingType])}>
      <div className='d-flex matching-type-configuration-header align-items-center pb-4'>
        <div className='heading-5 black'>{translationBase.CONFIGURATION.TITLE()}</div>
        <div className='selected-matching-type text-small bold'>{title}</div>
      </div>
      <div className='pt-4'>
        <ConfigurationComponent />
      </div>
    </div>
  );

};

export default MatchingTypeConfiguration;
